import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateFileTypeStatus = createSelector(
  [(store: RootState) => store.fileTypes.createFileTypeStatus],
  (data) => data
);